/**
 * MTL Image Lazy-Load Fix
 * Horizon's card-gallery.liquid eager-loads first slide of EVERY product card
 * when section.index < 5. This means ~12-24 product card images all fire requests
 * eagerly, blocking critical rendering. Fix: convert eager → lazy for cards beyond
 * the 4th (which are below the fold on mobile).
 */
(function() {
  'use strict';
  
  function fixEagerImages() {
    // Find all eager-loaded product card images
    const eagerImgs = Array.from(document.querySelectorAll('.product-grid img[loading="eager"], .resource-card img[loading="eager"], product-card img[loading="eager"], [class*="product-card"] img[loading="eager"]'));
    
    if (eagerImgs.length <= 4) return; // 4 or fewer — already optimal
    
    // Keep first 4 eager (above the fold on mobile + tablet)
    eagerImgs.slice(4).forEach(img => {
      img.setAttribute('loading', 'lazy');
      img.removeAttribute('fetchpriority');
    });
    
    // Also downgrade any high-priority hints on below-fold images
    document.querySelectorAll('.product-grid img[fetchpriority="high"], [class*="product-card"] img[fetchpriority="high"]').forEach((img, i) => {
      if (i >= 4) {
        img.removeAttribute('fetchpriority');
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixEagerImages);
  } else {
    fixEagerImages();
  }
  // Re-apply after lazy-load polyfills + sectionLoad events
  document.addEventListener('shopify:section:load', fixEagerImages);
})();
